import React from "react";
import { Routes, Route } from "react-router-dom";
import ComingSoon from "../../pages/public/ComingSoon";
import NotFound from "../../pages/public/NotFound";

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<ComingSoon />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
